import { IModuleProps } from '../../core/utils/modules.tsx';

import routes from './routes.tsx';

export default {
    name: 'universal',
    routes,
} as IModuleProps;
